import React from 'react';
import { Typography, Alert, List, Divider } from 'antd';
import { RefLanguage } from '../hooks/LanguageHooks';

const { Title, Paragraph, Text } = Typography;

function DocsGettingStartedPage() {
    const i18n = RefLanguage();

    const ScreenSection = ({ title, intro, screenshot, items }) => (
        <div style={{ marginBottom: '48px' }}>
            <Title level={3}>{title}</Title>
            <Paragraph style={{ fontSize: '16px', marginBottom: '24px' }}>
                {intro}
            </Paragraph>
            
            <div style={{ 
                textAlign: 'center', 
                marginBottom: '24px',
                padding: '16px',
                backgroundColor: '#f5f5f5',
                borderRadius: '8px'
            }}>
                <img 
                    src={screenshot} 
                    alt={title}
                    style={{ 
                        maxWidth: '100%', 
                        height: 'auto',
                        borderRadius: '4px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                    }}
                />
            </div>

            <List
                dataSource={items}
                renderItem={(item, index) => (
                    <List.Item style={{ alignItems: 'flex-start', border: 'none', paddingLeft: 0 }}>
                        <div style={{ width: '100%' }}>
                            <Text strong style={{ fontSize: '16px' }}>
                                <span style={{ 
                                    display: 'inline-block',
                                    width: '24px',
                                    height: '24px',
                                    lineHeight: '24px',
                                    textAlign: 'center',
                                    backgroundColor: '#1890ff',
                                    color: 'white',
                                    borderRadius: '50%',
                                    marginRight: '12px',
                                    fontSize: '14px'
                                }}>
                                    {index + 1}
                                </span>
                                {item.title}
                            </Text>
                            <Paragraph style={{ marginTop: '8px', marginLeft: '36px', marginBottom: '16px' }}>
                                {item.description}
                            </Paragraph>
                        </div>
                    </List.Item>
                )}
            />
        </div>
    );

    return (
        <div style={{ maxWidth: 1000, margin: '0 auto', padding: '24px' }}>
            <Typography>
                <Title level={2}>{i18n.t("docsGettingStartedTitle")}</Title>
                
                <Paragraph style={{ fontSize: '16px', marginBottom: '32px' }}>
                    {i18n.t("docsGettingStartedIntro")}
                </Paragraph>

                <Alert
                    message={i18n.t("docsGettingStartedTip")}
                    description={i18n.t("docsGettingStartedTipText")}
                    type="info"
                    showIcon
                    style={{ marginBottom: '48px' }}
                />

                <Divider />

                <ScreenSection
                    title={i18n.t("docsGettingStartedScreen1Title")}
                    intro={i18n.t("docsGettingStartedScreen1Intro")}
                    screenshot="/screenshots/EUKARYOME_01.webp"
                    items={[
                        {
                            title: i18n.t("docsGettingStartedScreen1Item1"),
                            description: i18n.t("docsGettingStartedScreen1Item1Desc")
                        },
                        {
                            title: i18n.t("docsGettingStartedScreen1Item2"),
                            description: i18n.t("docsGettingStartedScreen1Item2Desc")
                        },
                        {
                            title: i18n.t("docsGettingStartedScreen1Item3"),
                            description: i18n.t("docsGettingStartedScreen1Item3Desc")
                        }
                    ]}
                />

                <Divider />

                <ScreenSection
                    title={i18n.t("docsGettingStartedScreen2Title")}
                    intro={i18n.t("docsGettingStartedScreen2Intro")}
                    screenshot="/screenshots/EUKARYOME_02.webp"
                    items={[
                        {
                            title: i18n.t("docsGettingStartedScreen2Item1"),
                            description: i18n.t("docsGettingStartedScreen2Item1Desc")
                        },
                        {
                            title: i18n.t("docsGettingStartedScreen2Item2"),
                            description: i18n.t("docsGettingStartedScreen2Item2Desc")
                        },
                        {
                            title: i18n.t("docsGettingStartedScreen2Item3"),
                            description: i18n.t("docsGettingStartedScreen2Item3Desc")
                        }
                    ]}
                />

                <Divider />

                <ScreenSection
                    title={i18n.t("docsGettingStartedScreen3Title")}
                    intro={i18n.t("docsGettingStartedScreen3Intro")}
                    screenshot="/screenshots/EUKARYOME_03.webp"
                    items={[
                        {
                            title: i18n.t("docsGettingStartedScreen3Item1"),
                            description: i18n.t("docsGettingStartedScreen3Item1Desc")
                        },
                        {
                            title: i18n.t("docsGettingStartedScreen3Item2"),
                            description: i18n.t("docsGettingStartedScreen3Item2Desc")
                        },
                        {
                            title: i18n.t("docsGettingStartedScreen3Item3"),
                            description: i18n.t("docsGettingStartedScreen3Item3Desc")
                        }
                    ]}
                />
            </Typography>
        </div>
    );
}

export default DocsGettingStartedPage;
